.insightIconsWrapper {
  position: relative;
  display: flex;
  justify-content: center;

  &:not(.disabled):hover {
    transform: scale(1.25);
  }
}

.disabled {
  /* marker class toggled via classnames */
}

.styledImg {
  position: absolute;
  right: 0;
}
